var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.395 13.5a.75.75 0 0 1-.548-.24L3.202 9.382a.75.75 0 0 1 1.095-1.027l3.09 3.292 6.308-6.9a.75.75 0 1 1 1.11 1.005l-6.855 7.5a.75.75 0 0 1-.548.248z"
  })));
};
export default SvgCheck;